$ = require 'jquery'
Singleton = require '../../pattern/singleton'
Elements = require './elements'
Clipboard = require 'clipboard'
require 'query-command-supported'

module.exports =
class MailAddressCopy extends Singleton

  selector       : '.section-contact'
  btnSelector    : '.mail .link-inner'
  txtSelector    : '.detail-text a'
  balloonSelector: '.mail .balloon'

  constructor: ->
    super

    @$window = Elements.$window
      .one 'pagesLoaded', @onPagesLoaded
    @$body   = Elements.$body

    @shownBalloon = false

  onPagesLoaded: =>
    @$section = $ @selector
    @$btn     = @$section.find @btnSelector
      .on 'click', @onBtnClicked
    @$txt     = @$btn.find @txtSelector
      .on 'click', @onTxtClicked
    @$balloon = @$section.find @balloonSelector

    @txt     = @$txt.text()
    @hasCopy = document.queryCommandSupported 'copy'

    if @hasCopy
      new Clipboard @$btn.get(0)

  onBtnClicked: =>
    return if @shownBalloon or !@hasCopy

    @$balloon
      .velocity
        scale: [ 1, 0 ]
      ,
        duration: 200
        easing  : 'easeOutSine'
        display : 'block'
      .velocity
        translateY: -10
      ,
        duration: 100
        easing  : 'easeOutSine'
      .velocity
        translateY: 0
      ,
        duration: 100
        easing  : 'easeOutSine'

    @shownBalloon = true

    setTimeout =>
      @$balloon.velocity
        scale: 0
      ,
        duration: 200
        easing  : 'easeOutSine'
        display : 'none'
        complete: =>
          @shownBalloon = false
    , 3000

  onTxtClicked: (e) =>
    if @hasCopy
      e.preventDefault()
      e.currentTarget.href = ''



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/mail-address-copy.coffee